import React, {useEffect, useState, useContext} from 'react';
import SeaServiceJumbo from 'components/SeaservicesJumbo';
import {useGetUserSeaservicesSummary, useGetExpirationDates} from 'hooks/';
import AlertDialog from '../components/AlertDialog';
import LoadingPage, {CloudErrorPage} from 'components/LoadingPage';
import SeaServiceUpcomingDates from '../components/SeaServiceUpcomingDates';
import OriginalChecklist from 'components/widgets/checklists/OriginalChecklist';
import RenewalChecklist from 'components/widgets/checklists/RenewalChecklist';
import UpgradeChecklist from 'components/widgets/checklists/UpgradeChecklist';
import {Page} from 'components';
import {UserContext} from 'context/UserContext';
import EndorsementsTab from './EndorsementsTab';
import ApplicationAwaitingSignature from 'components/widgets/ApplicationAwaitingSignature';
import ApplicationThankYou from 'pages/ApplicationThankYou';

const endorsements = {
    name: 'My Endorsements',
    component: EndorsementsTab,
};

const dates = {
    name: 'Upcoming Dates',
    component: SeaServiceUpcomingDates,
};

const originalChecklist = {
    name: 'Original',
    component: OriginalChecklist,
};

const renewalChecklist = {
    name: 'Renewal',
    component: RenewalChecklist,
};

const upgradeChecklist = {
    name: 'Upgrade',
    component: UpgradeChecklist,
};

const applicationPending = {
    name: 'Pending Application',
    component: ApplicationAwaitingSignature,
}

const applicationSubmitted = {
    name: 'Submitted Application',
    component: ApplicationThankYou,
}

const CredentialPage = ({useTitle}) => {
    const [tabs, setTabs] = useState([]);
    const sss = useGetUserSeaservicesSummary(true);
    const expirationDates = useGetExpirationDates();
    const {applications, profile, hasMmlds} = useContext(UserContext);

    useEffect(() => {
        if (applications?.application_active && applications?.application_status === 'sent_to_user_for_signature') {
            setTabs([
                applicationPending,
                endorsements,
                dates,
            ]);
        } else if (applications?.application_active) {
            // @TODO add tracker
            setTabs([
                applicationSubmitted,
                endorsements,
                dates,
            ]);
        } else if (hasMmlds || profile?.applicant_previous_mmc) {
            setTabs([renewalChecklist, upgradeChecklist, endorsements, dates]);
        } else {
            setTabs([originalChecklist, endorsements, dates]);
        }
    }, [applications, hasMmlds, profile]);

    if (sss?.isLoading) {
        return <LoadingPage />;
    } else if (sss?.error) {
        const error = sss?.error;
        if (process.env.NODE_ENV === 'development') {
            return (
                <CloudErrorPage>
                    <AlertDialog title='Data Load Error' message={error} />
                </CloudErrorPage>
            );
        } else {
            window.dataLayer.push({
                event: 'data_load_error',
                data: {
                    url: window.location.href,
                    endpoint: error?.endpoint,
                    status: error?.status,
                },
            });
            return <CloudErrorPage />;
        }
    } else {
        return (
            <>
                <SeaServiceJumbo summary={sss?.data} />
                <Page
                    tabs={tabs}
                    pageUrl='home'
                    componentProps={{
                        sss: sss,
                        expirationDates: expirationDates,
                    }}
                    useTitle={useTitle}
                />
            </>
        );
    }
};

export default CredentialPage;
